export const Colors = {
    PRIMARY_BACKGROUND:"#fff",

    PRIMARY_BLUE: "#458FF6",
    SECUNDARY_BLUE: "#67C3F3",

    PRIMARY_COLOR_FONT: "#020202"

}

export const MEDIA = {
    EXTRA_LARGE_SCREEN: '@media(min-width: 1500px)',
    LARGE_SCREEN: '@media(min-width: 1400px)',
    MEDIUM_SCREEN: '@media(max-width: 1000px)',
    SMALL_SCREEN:'@media(max-width: 640px)'
}


